<template>
  <div>
    <CContainer>
      <CRow class="justify-content-center mt-4">
        <CCol md="12" class="text-center">
          <h1 class="mb-4">Add Substitute Teacher</h1>
          <div class="mb-2 max-w-500 m-auto text-start">
            <CreateSubstituteForm :is-in-view="true" />
          </div>
        </CCol>
      </CRow>
    </CContainer>
    <SubstituteUsersDataTable ref="SubstituteUsersDataTable" />
  </div>
</template>
<script>
import SubstituteUsersDataTable from "@/components/DataTables/SubstituteUsersDataTable"
import CreateSubstituteForm from "@/components/Forms/CreateSubstituteForm"

export default {
  name: "SubstituteUsers",
  components: { SubstituteUsersDataTable, CreateSubstituteForm },
  methods: {
    refreshDataTable(timeout) {
      setTimeout(() => {
        this.$refs.SubstituteUsersDataTable.refreshDataTable()
      }, timeout)
    }
  }
}
</script>
